// Board assets (icons, figures, the world map, textures, sound effects and
// the Look picker's cards) are served from R2 at a versioned path, never from
// the app: the editor and every render load them from there. The
// scripts/gen-explainer-*.mjs generators write them to explainer-assets/
// (gitignored) and scripts/upload-explainer-assets.mjs uploads that folder.
// Files there never change: a changed asset is uploaded under the next
// version, then EXPLAINER_ASSET_VERSION is bumped here (upload first, since
// Cloudflare caches a 404). The JSON files are fetched cross-origin, so a
// Cloudflare response-header rule sends Access-Control-Allow-Origin: * for
// media.easy-peasy.ai/explainer/*.

export const EXPLAINER_ASSET_VERSION = 'v2';

const ASSET_BASE = `https://media.easy-peasy.ai/explainer/${EXPLAINER_ASSET_VERSION}/`;

declare global {
  // Renders can load another copy instead, e.g. local files before they are
  // uploaded: `staticFile('/')` with `--public-dir=../explainer-assets`.

  var __EXPLAINER_ASSET_BASE__: string | undefined;
}

/** URL of a board asset, e.g. "explainer-icons/x.svg" or "cards/preview.mp4". */
export function assetUrl(path: string): string {
  const file = path.replace(/^\/+/, '');
  return `${globalThis.__EXPLAINER_ASSET_BASE__ || ASSET_BASE}${file}`;
}

/** A Fluent Emoji Flat icon (MIT), see scripts/gen-explainer-icons.mjs. */
/**
 * An icon field that names one of the user's pictures (`image:<id>`) where
 * only an icon can go draws the picture icon instead.
 */
export const iconFileName = (name: string) =>
  name.startsWith('image:') ? 'framed-picture' : name;

export const iconUrl = (name: string) =>
  assetUrl(`explainer-icons/${encodeURIComponent(iconFileName(name))}.svg`);
